import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import coreReducer from '../core/duck';
import scoutReportReducer from '../features/scout-report/duck';

const rootReducer = combineReducers({
  core: coreReducer,
  scoutReport: scoutReportReducer,
  routing
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/rootReducer.js